const HOUR_SECONDS = 3600;

const FALLBACK_WAIT_SECONDS = 60;

function isLongWait(seconds?: number) {
  return (seconds ?? FALLBACK_WAIT_SECONDS) >= HOUR_SECONDS;
}

function toWholeHours(seconds?: number) {
  return Math.ceil((seconds ?? FALLBACK_WAIT_SECONDS) / HOUR_SECONDS);
}

export {HOUR_SECONDS, FALLBACK_WAIT_SECONDS, isLongWait, toWholeHours};
